import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';
import cn from 'classnames';
import TextCropper from '@omilia/text-cropper';

import { dictionaryType } from 'types';
import ArchivedIcon from 'components/SelectableList/components/ArchivedIcon';
import './style.scss';

export default class DictionaryItem extends Component {
  static propTypes = {
    isArchived: PropTypes.bool,
    model: dictionaryType,
  };

  shouldComponentUpdate(nextProps) {
    return !_isEqual(nextProps.model, this.props.model);
  }

  render() {
    const { model, isArchived } = this.props;
    return (
      <div
        styleName={cn('dictionary__item', {
          'is-archived': isArchived,
        })}
      >
        <div data-test="dictionary-name" styleName="dictionary__item__name">
          <TextCropper styleName="cropper" text={model.name} />
        </div>
        <div
          data-test="dictionary-entries"
          styleName="dictionary__item__entries"
        >
          <span styleName="dictionary__item__entries__label">Tokens:</span>
          <span styleName="dictionary__item__entries__number">
            {model.total_count}
          </span>
        </div>
        <div styleName="dictionary__item__icons">
          {isArchived && (
            <ArchivedIcon data-test="archived" name="Dictionary" />
          )}
        </div>
      </div>
    );
  }
}
